module.exports = __webpack_public_path__ + "img/icon-s5.4d44d49.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/web/signStatistics/icon-s5.png
// module id = P3hY
// module chunks = 0 4 5 9